var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "head-cart-item row",
      class: { disable: _vm.product.attributes.salable === false }
    },
    [
      _c("div", { staticClass: "head-cart-item-image col-xs-3" }, [
        _c("a", { attrs: { href: _vm.product.attributes.detail_url } }, [
          _c("img", { attrs: { src: _vm.product.attributes.pic_url } })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "head-cart-item-info col-xs-5" }, [
        _c("a", { attrs: { href: _vm.product.attributes.detail_url } }, [
          _c("b", [_vm._v(_vm._s(_vm.product.attributes.name))])
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(_vm.strings["quantity"]) +
              ": " +
              _vm._s(_vm.product.quantity)
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(_vm.strings["size"]) +
              ": " +
              _vm._s(_vm.product.attributes.size)
          )
        ]),
        _vm._v(" "),
        _vm.product.attributes.description_color !== ""
          ? _c("div", [
              _vm._v(
                _vm._s(_vm.strings["color"]) +
                  ": " +
                  _vm._s(_vm.product.attributes.description_color)
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "head-cart-item-numbers col-xs-3" }, [
        _vm.product.attributes.is_on_sale
          ? _c("div", { staticClass: "head-cart-item-baseprice" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.currency) +
                  " " +
                  _vm._s(_vm.product.attributes.base_price) +
                  "\n        "
              )
            ])
          : _vm.product.attributes.is_on_promo
          ? _c(
              "div",
              { staticClass: "head-cart-item-baseprice before-promo" },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.currency) +
                    " " +
                    _vm._s(_vm.product.attributes.price_original) +
                    "\n        "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.product.attributes.salable
          ? _c("div", { staticClass: "head-cart-item-price" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.currency) +
                  " " +
                  _vm._s(_vm.product.attributes.price) +
                  "\n        "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "head-cart-item-actions col-xs-1",
          class: { updating: _vm.product.updating }
        },
        [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  return _vm.$emit("remove")
                }
              }
            },
            [
              _c("i", { staticClass: "fal fa-times" }),
              _c("i", { staticClass: "far fa-spinner-third fa-spin" })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.product.attributes.salable === false
        ? _c("div", { staticClass: "head-cart-item-notsalable col-xs-12" }, [
            _vm._v(_vm._s(_vm.strings["price_error"]))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }